import { DatePipe, formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/Service/Common.service';
import { Module } from 'src/app/Service/element-details.data.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { IProjectElementDetailsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { ElementdetailsService } from 'src/app/Service/elementdetails/elementdetails.service';
import { IElementDetailsViewModel, IElementDetailsDynamicOutputModel, IElementDetailsDynamicInputModel } from 'src/app/ViewModel/ElementDetailsModel';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
@Component({
  selector: 'app-stage-wise-dashboard',
  templateUrl: './stage-wise-dashboard.component.html',
  styleUrls: ['./stage-wise-dashboard.component.css']
})
export class StageWiseDashboardComponent implements OnInit {
  projectId!: number;
  groupId!: number;
  public structurelist: any[] = [];
  public reportServer!: string | null;
  public reportUrl!: string | null;
  public showParameters!: string;
  public parameters: any;
  public language!: string;
  public height!: number;
  public width!: number;
  public toolbar!: string;

  DCI_Type!: FormGroup;
  CCNType!: FormGroup;
  DocType!: FormGroup;

  public projectCode!: string;
  public tranType!: string;
  public isStatic!: string;
  public start = new Date();
  public end = new Date();
  public startdate!: string;
  public enddate!: string;
  public structureId!: string | null;
  public ccnTypeList!: IElementDetailsDynamicOutputModel[];
  public docTypeList!: IElementDetailsDynamicOutputModel[];
  public scheduleTypeList!: IElementDetailsDynamicOutputModel[];
  public SelectedccnTypeList: string[] = [];
  public SelecteddocTypeList: string[] = ['1286'];
  public SelectedscheduleTypeList: string[] = [];
  memberId: number = 0;
  public projectdetails!: ProjectViewModel;
  public selectedDocTypes: string[] = ['DWG'];

  constructor(
    private commonService: CommonService,
    private projInfoService: ProjectInfoService,
    private formBuilder: FormBuilder,
    public datepipe: DatePipe,
    private elementdetailsService: ElementdetailsService,
    private _projService: ProjectInfoService,
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.projectCode = this.commonService.getProjectCode();
    var date = new Date();
    this.start = new Date(date.getFullYear(), date.getMonth(), 1);
    this.end = new Date();
    this.projectdetails = this.commonService.getCurrentProjectDetails();
    if (this.projectdetails.startDate)
      this.start = new Date(this.projectdetails.startDate);
    this.getStructureList();
    this.bindScheduleTypes();
    this.bindDOCType();
    this.bindCCNType();
    this.DCI_Type = this.formBuilder.group({
      dci_dwg: new FormControl(true),
      ext_dci: new FormControl(true),
      std_drawing: new FormControl(true),
      ven_dwg: new FormControl(true),
    });
    this.CCNType = this.formBuilder.group({
      external: new FormControl(true),
      internal: new FormControl(true),
      fcn: new FormControl(true),
    });
    this.DocType = this.formBuilder.group({
      doc: new FormControl(true),
      dwg: new FormControl(false),
    });
    this.tranType = "count";
    this.isStatic = "0";
  }

  public EmbedSSRSReport() {
    this.language = "en-us";
    this.width = 1000;
    this.height = 620;
    this.toolbar = "true";
    this.showParameters = "false";
    this.parameters = {
      "Tran_Type": this.tranType,
      "Project_Id": this.projectId,
      "Project_Code": this.projectCode,
      "Group_Id": this.groupId,
      "IsStatic": this.isStatic,
      "CCN_Type": this.SelectedccnTypeList && this.SelectedccnTypeList.length > 0 ? this.SelectedccnTypeList.map(x => x).join(",") : null,
      "Schedule_Type": this.SelectedscheduleTypeList && this.SelectedscheduleTypeList.length > 0 ? this.SelectedscheduleTypeList.map(x => x).join(",") : null,
      "Doc_Drawing": this.SelecteddocTypeList && this.SelecteddocTypeList.length > 0 ? this.SelecteddocTypeList.map(x => x).join(",") : null,
      "Doc_buliding": this.structureId,
      "From_Date": this.startdate,
      "To_Date": this.enddate,
    }
    this.loaderService.isLoading.next(false);
  }

  async getStructureList() {
    let x: IElementDetailsDynamicInputModel = {
      de_Description: 'Structure / Package',
      isProjectSpecific: true,
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: 2
    };
    await this.elementdetailsService.GetElementDetailsDynamic(x).toPromise().then(res => {
      if (res && res.length > 0) {
        res = res.map(l => {
          let obj: IElementDetailsDynamicOutputModel = {
            dE_Id: l.dE_Id,
            dE_Description: l.dE_Description,
            deD_Id: l.deD_Id,
            deD_Short_Description: l.deD_Short_Description,
            deD_Description: (l.deD_Short_Description ? l.deD_Short_Description.concat(' - ', (l.deD_Description ? l.deD_Description : "")) : ""),
            deD_CODE: l.deD_CODE,
            sort_By: l.sort_By,
            project_Id: l.project_Id,
            group_Id: l.group_Id,
            module_Id: l.module_Id,
            is_Active: l.is_Active
          }
          return obj;
        })
        this.structurelist = res;
      }
    });
  }

  async bindScheduleTypes() {
    let x: IElementDetailsDynamicInputModel = {
      de_Description: 'Schedule Type',
    };

    await this.elementdetailsService.GetElementDetailsDynamic(x).toPromise().then(res => {
      if (res && res.length > 0) {
        this.scheduleTypeList = res;
        res.forEach(s => {
          if (this.SelectedscheduleTypeList && s.deD_CODE)
            this.SelectedscheduleTypeList.push(s.deD_CODE.toString());
          else
            this.SelectedscheduleTypeList = [];
        })
      }
    });
  }

  async bindDOCType() {
    let x: IElementDetailsDynamicInputModel = {
      de_Description: 'DWG / DOC',
      isProjectSpecific: true,
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: 2
    };
    await this.elementdetailsService.GetElementDetailsDynamic(x).toPromise().then(res => {
      if (res && res.length > 0) {
        this.docTypeList = res;
      }
    });
  }

  async bindCCNType() {
    let x: IElementDetailsDynamicInputModel = {
      de_Description: 'CCN Type',
    };
    await this.elementdetailsService.GetElementDetailsDynamic(x).toPromise().then(res => {
      if (res && res.length > 0) {
        this.ccnTypeList = res;
      }
    });
  }

  selectedSturcture(value: any) {
    if (value.value > 0) {
      this.structureId = value.additionalValues.additionalValues.deD_Id.toString();
    } else {
      this.structureId = null;
    }
  }

  onDocTypeChange(event: any, EleDetail: IElementDetailsViewModel) {
    debugger
    if (event.checked && EleDetail.deD_Id)
      this.SelecteddocTypeList.push(EleDetail.deD_Id.toString())
    else
      this.SelecteddocTypeList.forEach((value, index) => {
        if (EleDetail.deD_Id && value == EleDetail.deD_Id.toString()) this.SelecteddocTypeList.splice(index, 1);
      });
  }

  onCCNTypeChange(event: any, EleDetail: IElementDetailsViewModel) {
    if (event.checked && EleDetail.deD_Id)
      this.SelectedccnTypeList.push(EleDetail.deD_Id.toString())
    else
      this.SelectedccnTypeList.forEach((value, index) => {
        if (EleDetail.deD_Id && value == EleDetail.deD_Id.toString()) this.SelectedccnTypeList.splice(index, 1);
      });
  }

  onScheduleTypeChange(event: any, EleDetail: IElementDetailsViewModel) {
    if (event.checked && EleDetail.deD_CODE)
      this.SelectedscheduleTypeList.push(EleDetail.deD_CODE.toString())
    else
      this.SelectedscheduleTypeList.forEach((value, index) => {
        if (EleDetail.deD_CODE && value == EleDetail.deD_CODE.toString()) this.SelectedscheduleTypeList.splice(index, 1);
      });
  }

  tranTypeChange(value: string) {
    this.tranType = value;
  }
  isStaticChange(value: string) {
    this.isStatic = value;
  }

  getStartDateValue(selectedText: Date) {
    this.start = selectedText;
  }

  getEndDateValue(selectedText: Date) {
    this.end = selectedText;
  }
  clearReport() {
    this.reportUrl = null;
    this.reportServer = null;
  }

  viewReport() {
    this.loaderService.isLoading.next(true);
    this.clearReport();

    this.startdate = formatDate(this.start, "MM/dd/yyyy HH:mm:ss", 'en-US');
    this.enddate = formatDate(this.end, "MM/dd/yyyy HH:mm:ss", 'en-US');

    this.reportServer = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/DrawingProjectProgressDashboard";
    this.reportUrl = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/DrawingProjectProgressDashboard";

    this.EmbedSSRSReport();
  }
}
